import { Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

const httpHeaders: HttpHeaders = new HttpHeaders({
  "Access-Control-Allow-Origin": "*",
  "Authorization": "Basic b3BlbnBheTpxV3NnMypANlokZlY="
});

@Injectable({
  providedIn: 'root'
})

export class InstallationService {

  constructor(private http: HttpClient) {}

  saveCredentials(body): Observable<any>{
    return this.http.post(`${environment.openpayLambdaUrl}/openpay/merchant-info`, body, {headers: httpHeaders});
  }
}
